import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { BASE_URL, fotoUrl } from '../api';
import { useAuth } from '../AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const OgrenciProfil: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { kullanici, subeGirisi } = useAuth();
  const isSuperAdmin = kullanici?.rol === 'super_admin' || subeGirisi !== null;
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [ogrenci, setOgrenci] = useState<any>(null);
  const [dersler, setDersler] = useState<any[]>([]);
  const [kredi, setKredi] = useState<any>({ bakiye: 0, gecmis: [] });
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hakModal, setHakModal] = useState(false);
  const [dondurModal, setDondurModal] = useState(false);
  const [cikisModal, setCikisModal] = useState(false);
  const [krediyukleModal, setKrediyukleModal] = useState(false);
  const [seciliDersId, setSeciliDersId] = useState('');
  const [hakForm, setHakForm] = useState({ ders_id:'', satin_alinan_hak:8, toplam_tutar:'', aciklama:'', hediye:false, borclu:false });
  const [dondurForm, setDondurForm] = useState({ ders_id:'', baslangic_tarihi:'', bitis_tarihi:'', sebep:'Sağlık', aciklama:'' });
  const [cikisAciklama, setCikisAciklama] = useState('');
  const [krediyukleForm, setKrediyukleForm] = useState({ tutar:'', odeme_yontemi:'Nakit', aciklama:'' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [duzenleModal, setDuzenleModal] = useState(false);
  const [duzenleForm, setDuzenleForm] = useState({ ad:'', soyad:'', email:'', tel:'', seviye:'', durum:'', cinsiyet:'', dogum_tarihi:'' });
  const [birlestirModal, setBirlestirModal] = useState(false);
  const [tumOgrenciler, setTumOgrenciler] = useState<any[]>([]);
  const [hedefId, setHedefId] = useState('');
  const [silModal, setSilModal] = useState(false);
  const [siliyor, setSiliyor] = useState(false);
  const [risk, setRisk] = useState<{ skor: number; seviye: string; sinyaller: any[] } | null>(null);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const [oRes, dRes, kRes, rRes] = await Promise.all([
        api.get(`/api/ogrenciler/${id}`),
        api.get('/api/dersler'),
        api.get(`/api/krediler/${id}`),
        api.get(`/api/ai/risk/${id}`).catch(() => null),
      ]);
      setOgrenci(oRes.data);
      setDersler(dRes.data);
      setKredi(kRes.data);
      if (rRes) setRisk(rRes.data);
    } catch (err) { console.error(err); }
    finally { setYukleniyor(false); }
  };
  useEffect(() => { yukle(); }, [id]);

  // Kişisel bilgiler (seviye dahil) tek hesaba ait; backend kilitliyse şube bunları değiştiremez
  const kisiselKilitli = ogrenci?.kisisel_duzenlenebilir === false;

  const duzenleAc = () => {
    setDuzenleForm({ ad: ogrenci.ad||'', soyad: ogrenci.soyad||'', email: ogrenci.email||'', tel: ogrenci.tel||'', seviye: ogrenci.seviye||'Başlangıç', durum: ogrenci.durum||'aktif', cinsiyet: ogrenci.cinsiyet||'', dogum_tarihi: ogrenci.dogum_tarihi?.slice(0,10)||'' });
    setHata('');
    setDuzenleModal(true);
  };

  const duzenleKaydet = async () => {
    if (!duzenleForm.ad || !duzenleForm.soyad || !duzenleForm.email) { setHata('Ad, soyad ve e-posta zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      await api.put(`/api/ogrenciler/${id}`, duzenleForm);
      setDuzenleModal(false);
      yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const hakKaydet = async () => {
    if (!hakForm.ders_id || (!hakForm.hediye && !hakForm.borclu && !hakForm.toplam_tutar)) { setHata('Ders ve tutar zorunlu'); return; }
    if (hakForm.borclu && !window.confirm(
      `${ogrenci?.ad} ${ogrenci?.soyad} bu derse 0 hakla eklenecek (kayıt kapalı olsa bile).\n\nÖğrenci yoklamada "katıldı" işaretlendikçe otomatik borca düşecek.\n\nDevam edilsin mi?`
    )) return;
    setKaydediliyor(true); setHata('');
    try {
      const res = await api.post('/api/ders-hakki', {
        ...hakForm, ogrenci_id: id,
        satin_alinan_hak: hakForm.borclu ? 0 : hakForm.satin_alinan_hak,
        toplam_tutar: (hakForm.hediye || hakForm.borclu) ? 0 : parseFloat(hakForm.toplam_tutar),
        hediye: hakForm.hediye,
      });
      alert(res.data.mesaj);
      setHakModal(false);
      setHakForm({ ders_id:'', satin_alinan_hak:8, toplam_tutar:'', aciklama:'', hediye:false, borclu:false });
      yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const dondurKaydet = async () => {
    if (!dondurForm.ders_id || !dondurForm.baslangic_tarihi || !dondurForm.bitis_tarihi) { setHata('Tum alanlar zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      await api.post('/api/ders-hakki/dondur', { ...dondurForm, ogrenci_id: id });
      alert('Kayit donduruldu');
      setDondurModal(false);
      yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const dondurCoz = async (dondurma_id: string) => {
    if (!window.confirm('Dondurmayi cozmeye emin misiniz?')) return;
    try { await api.put(`/api/ders-hakki/dondur/${dondurma_id}/coz`, {}); yukle(); }
    catch (err:any) { alert(err.response?.data?.hata||'Hata'); }
  };

  const derstenCik = async () => {
    if (!seciliDersId) return;
    setKaydediliyor(true); setHata('');
    try {
      const res = await api.post('/api/krediler/dersten-cik', {
        ogrenci_id: id, ders_id: seciliDersId, aciklama: cikisAciklama
      });
      alert(res.data.mesaj);
      setCikisModal(false);
      setCikisAciklama(''); setSeciliDersId('');
      yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const [geriAliniyor, setGeriAliniyor] = useState<string | null>(null);
  const hareketGeriAl = async (k: any) => {
    const ne = k.islem_turu === 'yukleme'
      ? `₺${parseFloat(k.tutar).toLocaleString('tr-TR')} bakiye yüklemesi`
      : `₺${parseFloat(k.tutar).toLocaleString('tr-TR')} ders hakkı alımı${k.ders_adi ? ` (${k.ders_adi})` : ''}`;
    if (!window.confirm(`Bu işlem geri alınsın mı?\n\n${ne}\n\nYükleme ise kazanılan TP ve kasa geliri de geri alınır. Ders hakkı ise (hiç kullanılmamışsa) paket silinir.`)) return;
    setGeriAliniyor(k.id);
    try {
      const res = await api.post(`/api/krediler/hareket/${k.id}/geri-al`);
      const d = res.data.detay || {};
      let msg = '✓ İşlem geri alındı.';
      if (d.tur === 'bakiye_yukleme') {
        msg += `\n₺${d.tutar?.toLocaleString('tr-TR')} bakiye kaldırıldı.`;
        if (d.tp_geri_alindi) msg += `\n${d.tp_geri_alindi} TP geri alındı.`;
        if (d.kasa_kaydi_silindi === false) msg += `\n\n⚠ Eşleşen kasa gelir kaydı bulunamadı — Kasa'yı elle kontrol edin.`;
      } else if (d.tur === 'ders_hakki_alimi') {
        msg += `\n${d.hak} ders hakkı paketi silindi, ₺${d.bakiyeye_donen?.toLocaleString('tr-TR')} bakiyeye döndü.`;
      }
      alert(msg);
      yukle();
    } catch (err:any) { alert(err.response?.data?.hata || 'Geri alınamadı'); }
    finally { setGeriAliniyor(null); }
  };

  const krediyukle = async () => {
    if (!krediyukleForm.tutar) { setHata('Tutar zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const res = await api.post('/api/krediler/yukle', {
        ogrenci_id: id,
        tutar: parseFloat(krediyukleForm.tutar),
        aciklama: krediyukleForm.aciklama || `${krediyukleForm.odeme_yontemi} ile kredi yukleme`,
      });
      alert(res.data.mesaj);
      setKrediyukleModal(false);
      setKrediyukleForm({ tutar:'', odeme_yontemi:'Nakit', aciklama:'' });
      yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const ogrenciSil = async () => {
    setSiliyor(true);
    try {
      await api.delete(`/api/ogrenciler/${id}`);
      navigate('/ogrenciler');
    } catch (err: any) { alert(err.response?.data?.hata || 'Silinemedi'); setSilModal(false); }
    finally { setSiliyor(false); }
  };

  const birimFiyat = hakForm.ders_id && hakForm.toplam_tutar && hakForm.satin_alinan_hak
    ? (parseFloat(hakForm.toplam_tutar) / hakForm.satin_alinan_hak).toFixed(2) : null;

  if (yukleniyor) return <div style={{ padding:24, color:textSec }}>Yukleniyor...</div>;
  if (!ogrenci) return <div style={{ padding:24, color:textSec }}>Ogrenci bulunamadi.</div>;

  return (
    <div style={{ padding:24 }}>
      <button onClick={() => navigate(-1)} style={{ border:'none', background:'none', cursor:'pointer', color:textSec, fontSize:13, marginBottom:16, padding:0 }}>
        ← Geri
      </button>

      {/* Profil */}
      <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:16, background:card, border:`1px solid ${border}`, borderRadius:10, padding:20 }}>
        <div style={{ position:'relative', cursor:'pointer' }}
          onClick={() => kisiselKilitli ? alert(ogrenci.kisisel_kilit_sebebi) : document.getElementById('foto-input')?.click()}>
          {ogrenci.foto_url
            ? <img src={fotoUrl(ogrenci.foto_url)} alt="" style={{ width:56, height:56, borderRadius:'50%', objectFit:'cover' }} />
            : <div style={{ width:56, height:56, borderRadius:'50%', background:isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', color:'#3C3489', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, fontWeight:600 }}>
                {ogrenci.ad?.charAt(0)}{ogrenci.soyad?.charAt(0)}
              </div>
          }
          <div style={{ position:'absolute', inset:0, borderRadius:'50%', background:'rgba(0,0,0,0.35)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'opacity .2s' }}
            onMouseEnter={e=>(e.currentTarget.style.opacity='1')} onMouseLeave={e=>(e.currentTarget.style.opacity='0')}>
            <span style={{ color:'white', fontSize:18 }}>↑</span>
          </div>
        </div>
        <input id="foto-input" type="file" accept="image/*" style={{ display:'none' }}
          onChange={async e => {
            const file = e.target.files?.[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('foto', file);
            try {
              await api.post(`/api/ogrenciler/${id}/foto`, formData);
              yukle();
            } catch (err: any) { alert(err.response?.data?.hata || 'Foto yuklenemedi'); }
          }} />
        <div style={{ flex:1 }}>
          <div style={{ fontSize:20, fontWeight:600 }}>{ogrenci.ad} {ogrenci.soyad}</div>
          <div style={{ fontSize:13, color:textSec, marginTop:2 }}>{ogrenci.email}{ogrenci.tel ? ` · ${ogrenci.tel}` : ''}</div>
        </div>
        <span style={{ background:isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', color:'#3B6D11', borderRadius:20, padding:'4px 12px', fontSize:12 }}>{ogrenci.seviye}</span>
        {risk && (() => {
          const renk = risk.seviye === 'yuksek' ? { bg: isDark ? 'rgba(228,75,74,0.12)' : '#FEE2E2', color:'#B91C1C', border:'#FECACA' }
                     : risk.seviye === 'orta'   ? { bg: isDark ? 'rgba(245,158,11,0.12)' : '#FEF3C7', color:'#92400E', border:'#FDE68A' }
                                                : { bg: isDark ? 'rgba(16,185,129,0.15)' : '#D1FAE5', color:'#065F46', border:'#A7F3D0' };
          const etiket = risk.seviye === 'yuksek' ? 'Yüksek risk' : risk.seviye === 'orta' ? 'Orta risk' : 'Düşük risk';
          return (
            <span title={risk.sinyaller.filter(s => s.puan > 0).map(s => s.mesaj).join(' · ')}
              style={{ background: renk.bg, color: renk.color, border: `1px solid ${renk.border}`, borderRadius:20, padding:'4px 12px', fontSize:12, fontWeight:600, cursor:'default', whiteSpace:'nowrap' }}>
              {etiket} · {risk.skor}
            </span>
          );
        })()}
        <button onClick={duzenleAc}
          style={{ border:`1px solid ${border}`, background:card, padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13, color:'#534AB7' }}>
          Düzenle
        </button>
        <button onClick={async () => {
            const res = await api.get('/api/ogrenciler');
            setTumOgrenciler(res.data.filter((o:any) => o.id !== id));
            setHedefId('');
            setBirlestirModal(true);
          }}
          style={{ border:`1px solid ${border}`, background:card, padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13, color:textSec }}
          title="Yanlış email ile oluşmuş hesapları birleştir">
          ⇌ Birleştir
        </button>
        {isSuperAdmin && (
          <button onClick={() => setSilModal(true)}
            style={{ border:'1px solid #ffcccc', background:'#fff5f5', color:'#c0392b', padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13, fontWeight:600 }}>
            Sil
          </button>
        )}
      </div>

      {/* Kredi bakiyesi */}
      <div style={{ background: kredi.bakiye > 0 ? (isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE') : cardAlt, border: kredi.bakiye > 0 ? '1px solid #1D9E75' : `1px solid ${border}`, borderRadius:10, padding:'14px 18px', marginBottom:16, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color: kredi.bakiye > 0 ? '#085041' : isDark ? '#bbb' : '#555' }}>Kredi bakiyesi</div>
          <div style={{ fontSize:11, color: kredi.bakiye > 0 ? '#3B6D11' : textMuted, marginTop:2 }}>
            {kredi.bakiye > 0 ? 'Ders hakki aliminda kullanilabilir' : 'Kredi yuklemek icin butona basin'}
          </div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div style={{ fontSize:24, fontWeight:700, color: kredi.bakiye > 0 ? '#085041' : textMuted }}>
            ₺{kredi.bakiye.toLocaleString('tr-TR')}
          </div>
          <button onClick={() => { setHata(''); setKrediyukleModal(true); }}
            style={{ background:'#1D9E75', color:'white', border:'none', padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13 }}>
            + Kredi yukle
          </button>
        </div>
      </div>

      {/* Dersler baslik */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
        <div style={{ fontSize:15, fontWeight:600 }}>Kayitli dersler</div>
        <div style={{ display:'flex', gap:8 }}>
          <button onClick={() => { setSeciliDersId(''); setHata(''); setCikisModal(true); }}
            style={{ border:`1px solid ${border}`, background:card, padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13, color:'#e24b4a' }}>
            Dersten cik
          </button>
          <button onClick={() => { setHata(''); setHakModal(true); }}
            style={{ background:'#534AB7', color:'white', border:'none', padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:13 }}>
            + Ders hakki ekle
          </button>
        </div>
      </div>

      {ogrenci.borclu_pasif_dersler?.length > 0 && (
        <div style={{ background:isDark ? 'rgba(228,75,74,0.1)' : '#FCEBEB', border:'1px solid #e24b4a', borderRadius:10, padding:16, marginBottom:16 }}>
          <div style={{ fontWeight:700, fontSize:13, color:'#A32D2D', marginBottom:8 }}>⚠️ Kayıttan çıkılmış derslerde ödenmemiş borç var</div>
          <div style={{ display:'grid', gap:6 }}>
            {ogrenci.borclu_pasif_dersler.map((d:any) => (
              <div key={d.ders_id} style={{ fontSize:12, color:'#A32D2D' }}>
                <strong>{d.ders_adi}</strong> — {Math.abs(d.borc_hak)} hak (₺{Math.abs(parseFloat(d.borc_tutar)).toLocaleString('tr-TR')}) borçlu, kayıt artık aktif değil
              </div>
            ))}
          </div>
        </div>
      )}

      {ogrenci.dersler?.length === 0 ? (
        <div style={{ background:card, border:'1px dashed #ddd', borderRadius:10, padding:32, textAlign:'center', color:textMuted, fontSize:13, marginBottom:16 }}>
          Henuz hicbir derse kayitli degil.
        </div>
      ) : (
        <div style={{ display:'grid', gap:10, marginBottom:16 }}>
          {ogrenci.dersler?.map((d:any) => (
            <div key={d.ders_id} style={{ background:card, border:`1px solid ${border}`, borderRadius:10, padding:16 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
                <div>
                  <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontWeight:600, fontSize:14 }}>{d.ders_adi}</span>
                    {d.ders_aktif === false && (
                      <span style={{ background:isDark ? '#252525' : '#f3f3f3', color:isDark ? '#999' : '#999', borderRadius:20, padding:'2px 8px', fontSize:11, fontWeight:500 }}>Arşivlendi</span>
                    )}
                  </div>
                  <div style={{ fontSize:12, color:textSec, marginTop:2 }}>
                    Birim: ₺{parseFloat(d.birim_fiyat||0).toLocaleString('tr-TR')} · Toplam deger: ₺{(parseFloat(d.kalan_hak||0) * parseFloat(d.birim_fiyat||0)).toLocaleString('tr-TR')}
                  </div>
                </div>
                <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                  {d.donduruldu
                    ? <span style={{ background:'#E6F1FB', color:'#0C447C', borderRadius:20, padding:'3px 10px', fontSize:11 }}>Donduruldu</span>
                    : <span style={{ background: d.kalan_hak > 3 ? (isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE') : d.kalan_hak > 0 ? (isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA') : (isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB'), color: d.kalan_hak > 3 ? '#3B6D11' : d.kalan_hak > 0 ? '#854F0B' : '#A32D2D', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:500 }}>
                        {d.kalan_hak} hak kaldi
                      </span>
                  }
                  <button onClick={() => { setDondurForm(p=>({...p,ders_id:d.ders_id})); setHata(''); setDondurModal(true); }}
                    style={{ border:`1px solid ${border}`, background:card, padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>
                    Dondur
                  </button>
                </div>
              </div>
              {ogrenci.dondurma_gecmisi?.filter((dg:any)=>dg.ders_id===d.ders_id).map((dg:any)=>(
                <div key={dg.id} style={{ marginTop:8, background:'#E6F1FB', borderRadius:6, padding:'6px 10px', fontSize:11, color:'#0C447C', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span>{dg.baslangic_tarihi?.slice(0,10)} — {dg.bitis_tarihi?.slice(0,10)} ({dg.sebep})</span>
                  {dg.aktif && <button onClick={() => dondurCoz(dg.id)} style={{ border:'none', background:'#0C447C', color:'white', padding:'2px 8px', borderRadius:4, cursor:'pointer', fontSize:10 }}>Coz</button>}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Kredi gecmisi */}
      {kredi.gecmis?.length > 0 && (
        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:12 }}>Kredi gecmisi</div>
          <div style={{ background:card, border:`1px solid ${border}`, borderRadius:10, overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr style={{ borderBottom:`1px solid ${border}` }}>
                {['Tarih','Aciklama','Tutar','Tip',''].map((h,hi)=>(
                  <th key={hi} style={{ textAlign:'left', padding:'8px 14px', fontSize:11, color:textMuted, fontWeight:500 }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {kredi.gecmis.map((k:any,i:number)=>(
                  <tr key={k.id} style={{ borderBottom:i<kredi.gecmis.length-1?`1px solid ${borderSub}`:'none' }}>
                    <td style={{ padding:'8px 14px', color:isDark ? '#bbb' : '#555' }}>{k.olusturuldu?.slice(0,10)}</td>
                    <td style={{ padding:'8px 14px' }}>{k.aciklama}{k.ders_adi?` (${k.ders_adi})`:''}</td>
                    <td style={{ padding:'8px 14px', fontWeight:500, color:k.islem_turu==='harcama'?'#A32D2D':k.islem_turu==='hediye'?'#92400e':'#3B6D11' }}>
                      {k.islem_turu==='harcama'?'-':k.islem_turu==='hediye'?'🎁':'+' } {k.islem_turu==='hediye'?'Hediye':`₺${parseFloat(k.tutar).toLocaleString('tr-TR')}`}
                    </td>
                    <td style={{ padding:'8px 14px' }}>
                      <span style={{ background:k.islem_turu==='harcama'?(isDark?'rgba(228,75,74,0.15)':'#FCEBEB'):k.islem_turu==='iade'?(isDark?'rgba(59,130,246,0.15)':'#E6F1FB'):k.islem_turu==='hediye'?(isDark?'rgba(245,158,11,0.15)':'#fef3c7'):(isDark?'rgba(29,158,117,0.15)':'#EAF3DE'), color:k.islem_turu==='harcama'?'#A32D2D':k.islem_turu==='iade'?'#0C447C':k.islem_turu==='hediye'?'#92400e':'#3B6D11', borderRadius:20, padding:'2px 8px', fontSize:11 }}>
                        {k.islem_turu==='hediye'?'🎁 hediye':k.islem_turu}
                      </span>
                    </td>
                    <td style={{ padding:'8px 14px', textAlign:'right' }}>
                      {(k.islem_turu==='yukleme'||k.islem_turu==='harcama') && (
                        <button onClick={()=>hareketGeriAl(k)} disabled={geriAliniyor===k.id}
                          title="Bu işlemi geri al (kaza düzeltmesi)"
                          style={{ border:`1px solid ${border}`, background:card, color:textSec, borderRadius:6, padding:'3px 8px', fontSize:11, cursor:'pointer', whiteSpace:'nowrap' }}>
                          {geriAliniyor===k.id ? '...' : '↩ Geri al'}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Yoklama gecmisi */}
      {ogrenci.yoklama_gecmisi?.length > 0 && (
        <div>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:12 }}>Yoklama gecmisi</div>
          <div style={{ background:card, border:`1px solid ${border}`, borderRadius:10, overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr style={{ borderBottom:`1px solid ${border}` }}>
                {['Tarih','Ders','Durum'].map(h=>(
                  <th key={h} style={{ textAlign:'left', padding:'8px 14px', fontSize:11, color:textMuted, fontWeight:500 }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {ogrenci.yoklama_gecmisi.map((y:any,i:number)=>(
                  <tr key={i} style={{ borderBottom:i<ogrenci.yoklama_gecmisi.length-1?`1px solid ${borderSub}`:'none' }}>
                    <td style={{ padding:'8px 14px', color:isDark ? '#bbb' : '#555' }}>{y.tarih?.slice(0,10)}</td>
                    <td style={{ padding:'8px 14px', fontWeight:500 }}>{y.ders_adi}</td>
                    <td style={{ padding:'8px 14px' }}>
                      <span style={{ background:y.durum==='katildi'?(isDark?'rgba(29,158,117,0.15)':'#EAF3DE'):y.durum==='gelmedi'?(isDark?'rgba(228,75,74,0.15)':'#FCEBEB'):(isDark?'rgba(59,130,246,0.15)':'#E6F1FB'), color:y.durum==='katildi'?'#3B6D11':y.durum==='gelmedi'?'#A32D2D':'#0C447C', borderRadius:20, padding:'2px 8px', fontSize:11 }}>
                        {y.durum}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Kredi yukleme modali */}
      {krediyukleModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setKrediyukleModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:380 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:4 }}>Kredi yukle</div>
            <div style={{ fontSize:12, color:textSec, marginBottom:16 }}>{ogrenci.ad} {ogrenci.soyad} · Mevcut: ₺{kredi.bakiye.toLocaleString('tr-TR')}</div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Tutar (TL)</div>
              <input type="number" value={krediyukleForm.tutar} onChange={e=>setKrediyukleForm(p=>({...p,tutar:e.target.value}))} placeholder="0.00"
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Odeme yontemi</div>
              <select value={krediyukleForm.odeme_yontemi} onChange={e=>setKrediyukleForm(p=>({...p,odeme_yontemi:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                {['Nakit','Kart','EFT','iyzico'].map(o=><option key={o}>{o}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Not (opsiyonel)</div>
              <input value={krediyukleForm.aciklama} onChange={e=>setKrediyukleForm(p=>({...p,aciklama:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setKrediyukleModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>Iptal</button>
              <button onClick={krediyukle} disabled={kaydediliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#1D9E75', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor?'Yukleniyor...':'Krediyi yukle'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hak ekleme modali */}
      {hakModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setHakModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:420 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:10 }}>Ders hakki ekle</div>
            <div style={{ display:'flex', gap:6, marginBottom:12 }}>
              {([
                { key:'normal', label:'Normal', renk:'#534AB7', bg:isDark?'rgba(83,74,183,0.2)':'#EEEDFE' },
                { key:'hediye', label:'🎁 Hediye', renk:'#92400e', bg:'#fef3c7' },
                { key:'borclu', label:'🔴 Borçlu Başlat', renk:'#A32D2D', bg:isDark?'rgba(228,75,74,0.15)':'#FCEBEB' },
              ] as const).map(m => {
                const secili = m.key==='normal' ? (!hakForm.hediye && !hakForm.borclu) : m.key==='hediye' ? hakForm.hediye : hakForm.borclu;
                return (
                  <button key={m.key} type="button"
                    onClick={() => setHakForm(p => ({ ...p, hediye: m.key==='hediye', borclu: m.key==='borclu', toplam_tutar: '' }))}
                    style={{ flex:1, padding:'7px 6px', borderRadius:6, fontSize:11, fontWeight:600, cursor:'pointer',
                      border:`1px solid ${secili ? m.renk : '#ddd'}`,
                      background: secili ? m.bg : card, color: secili ? m.renk : isDark ? '#bbb' : '#555' }}>
                    {m.label}
                  </button>
                );
              })}
            </div>
            {hakForm.borclu && (
              <div style={{ background:isDark?'rgba(228,75,74,0.1)':'#FCEBEB', border:'1px solid #e24b4a', borderRadius:8, padding:'10px 12px', marginBottom:12, fontSize:12, color:'#A32D2D' }}>
                Öğrenci 0 hakla derse eklenir (kayıt kapalı olsa bile). Yoklamada "katıldı" işaretlendikçe otomatik borca düşer.
              </div>
            )}
            {!hakForm.hediye && !hakForm.borclu && (
              <div style={{ fontSize:12, color:'#888', marginBottom:12 }}>Kredi bakiyesi: <b style={{ color: kredi.bakiye > 0 ? '#085041' : '#A32D2D' }}>₺{kredi.bakiye.toLocaleString('tr-TR')}</b></div>
            )}
            {!hakForm.hediye && !hakForm.borclu && kredi.bakiye <= 0 && (
              <div style={{ background:'#FCEBEB', border:'1px solid #e24b4a', borderRadius:8, padding:'10px 12px', marginBottom:12, fontSize:12, color:'#A32D2D' }}>
                Yetersiz kredi! Once kredi yukleyin.
              </div>
            )}
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Ders</div>
              <select value={hakForm.ders_id} onChange={e=>setHakForm(p=>({...p,ders_id:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                <option value="">-- Ders sec --</option>
                {dersler.map(d=><option key={d.id} value={d.id}>{d.ad}</option>)}
              </select>
            </div>
            {!hakForm.borclu && (
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
                <div>
                  <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Hak adedi</div>
                  <input type="number" value={hakForm.satin_alinan_hak} min={1}
                    onChange={e=>setHakForm(p=>({...p,satin_alinan_hak:parseInt(e.target.value)||1}))}
                    style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
                </div>
                {!hakForm.hediye ? (
                  <div>
                    <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Toplam tutar (TL)</div>
                    <input type="number" value={hakForm.toplam_tutar} placeholder="0.00"
                      onChange={e=>setHakForm(p=>({...p,toplam_tutar:e.target.value}))}
                      style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
                  </div>
                ) : (
                  <div style={{ display:'flex', alignItems:'flex-end' }}>
                    <div style={{ background:'#fef3c7', border:'1px solid #fcd34d', borderRadius:8, padding:'8px 12px', fontSize:12, color:'#92400e', fontWeight:600, width:'100%' }}>
                      🎁 Ücretsiz eklenir
                    </div>
                  </div>
                )}
              </div>
            )}
            {(hakForm.hediye || hakForm.borclu) && (
              <div style={{ marginBottom:10 }}>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Açıklama (opsiyonel)</div>
                <input type="text" value={hakForm.aciklama}
                  onChange={e=>setHakForm(p=>({...p,aciklama:e.target.value}))}
                  placeholder={hakForm.borclu ? 'ör. Deneme dersi, ödeme sonra yapılacak...' : 'ör. Doğum günü hediyesi, telafi dersi...'}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
            )}
            {birimFiyat && !hakForm.hediye && !hakForm.borclu && (
              <div style={{ background:cardAlt, borderRadius:6, padding:'8px 12px', fontSize:12, marginBottom:10 }}>
                <div>Birim fiyat: <b>₺{birimFiyat}</b> / ders</div>
                {hakForm.toplam_tutar && kredi.bakiye < parseFloat(hakForm.toplam_tutar) && (
                  <div style={{ color:'#A32D2D', marginTop:4 }}>
                    Yetersiz kredi! Gereken: ₺{parseFloat(hakForm.toplam_tutar).toFixed(2)}, Mevcut: ₺{kredi.bakiye.toFixed(2)}
                  </div>
                )}
              </div>
            )}
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setHakModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>Iptal</button>
              <button onClick={hakKaydet} disabled={kaydediliyor || (!hakForm.hediye && !hakForm.borclu && kredi.bakiye <= 0)}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background: hakForm.borclu ? '#e24b4a' : hakForm.hediye ? '#f59e0b' : '#534AB7', color:'white', cursor:'pointer', fontSize:13, opacity: (!hakForm.hediye && !hakForm.borclu && kredi.bakiye <= 0) ? 0.5 : 1 }}>
                {kaydediliyor ? 'Kaydediliyor...' : hakForm.borclu ? '🔴 Borçlu Olarak Ekle' : hakForm.hediye ? `🎁 ${hakForm.satin_alinan_hak} Hak Hediye Et` : 'Hakki ekle'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Dondurma modali */}
      {dondurModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setDondurModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:400 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>Kayit dondur</div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Ders</div>
              <select value={dondurForm.ders_id} onChange={e=>setDondurForm(p=>({...p,ders_id:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                <option value="">-- Sec --</option>
                {ogrenci.dersler?.map((d:any)=><option key={d.ders_id} value={d.ders_id}>{d.ders_adi}</option>)}
              </select>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Baslangic</div>
                <input type="date" value={dondurForm.baslangic_tarihi} onChange={e=>setDondurForm(p=>({...p,baslangic_tarihi:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Bitis</div>
                <input type="date" value={dondurForm.bitis_tarihi} onChange={e=>setDondurForm(p=>({...p,bitis_tarihi:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Sebep</div>
              <select value={dondurForm.sebep} onChange={e=>setDondurForm(p=>({...p,sebep:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                {['Sağlık','Seyahat','Kişisel','Diğer'].map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setDondurModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>Iptal</button>
              <button onClick={dondurKaydet} disabled={kaydediliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#378ADD', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor?'Kaydediliyor...':'Dondur'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Duzenle modali */}
      {duzenleModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setDuzenleModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:420 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>Öğrenci bilgilerini düzenle</div>
            {kisiselKilitli && (
              <div style={{ background: isDark ? 'rgba(245,158,11,0.12)' : '#FEF3C7', color:'#92400E', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:12 }}>
                {ogrenci.kisisel_kilit_sebebi}
              </div>
            )}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Ad</div>
                <input value={duzenleForm.ad} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,ad:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Soyad</div>
                <input value={duzenleForm.soyad} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,soyad:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>E-posta</div>
              <input type="email" value={duzenleForm.email} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,email:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Telefon</div>
              <input value={duzenleForm.tel} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,tel:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Seviye</div>
                <select value={duzenleForm.seviye} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,seviye:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  <option>Başlangıç</option>
                  <option>Orta</option>
                  <option>İleri</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Cinsiyet</div>
                <select value={duzenleForm.cinsiyet} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,cinsiyet:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  <option value=''>—</option>
                  <option value='kadin'>Kadın</option>
                  <option value='erkek'>Erkek</option>
                  <option value='diger'>Diğer</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Durum</div>
                {/* Hesap durumu tüm şubelerde girişi etkiler; sadece merkez değiştirir */}
                <select value={duzenleForm.durum} disabled={!isSuperAdmin} title={isSuperAdmin ? '' : 'Hesap durumunu sadece merkez değiştirebilir'}
                  onChange={e=>setDuzenleForm(p=>({...p,durum:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  <option value="aktif">Aktif</option>
                  <option value="pasif">Pasif</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Doğum tarihi</div>
              <input type='date' value={duzenleForm.dogum_tarihi} disabled={kisiselKilitli} onChange={e=>setDuzenleForm(p=>({...p,dogum_tarihi:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setDuzenleModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>İptal</button>
              <button onClick={duzenleKaydet} disabled={kaydediliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#534AB7', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor?'Kaydediliyor...':'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Dersten cikis modali */}
      {cikisModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setCikisModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:400 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:4 }}>Dersten cik</div>
            <div style={{ fontSize:12, color:textSec, marginBottom:16 }}>Kalan haklar TL olarak krediye yuklenir.</div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Ders</div>
              <select value={seciliDersId} onChange={e=>setSeciliDersId(e.target.value)}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                <option value="">-- Sec --</option>
                {ogrenci.dersler?.map((d:any)=><option key={d.ders_id} value={d.ders_id}>{d.ders_adi} ({d.kalan_hak} hak)</option>)}
              </select>
            </div>
            {seciliDersId && (() => {
              const d = ogrenci.dersler?.find((d:any)=>d.ders_id===seciliDersId);
              if (!d) return null;
              const iade = parseFloat(d.kalan_hak||0) * parseFloat(d.birim_fiyat||0);
              return (
                <div style={{ background:isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', borderRadius:8, padding:'10px 12px', fontSize:12, color:'#085041', marginBottom:10 }}>
                  {d.kalan_hak} hak × ₺{parseFloat(d.birim_fiyat||0).toLocaleString('tr-TR')} = <b>₺{iade.toLocaleString('tr-TR')} krediye yuklenir</b>
                </div>
              );
            })()}
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Aciklama (opsiyonel)</div>
              <input value={cikisAciklama} onChange={e=>setCikisAciklama(e.target.value)}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setCikisModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>Iptal</button>
              <button onClick={derstenCik} disabled={kaydediliyor||!seciliDersId}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#e24b4a', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor?'Isleniyor...':'Dersten cik'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Öğrenci sil modali */}
      {silModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 }}
          onClick={e=>{if(e.target===e.currentTarget)setSilModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:28, width:420 }}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:8, color:'#c0392b' }}>Öğrenciyi sil</div>
            <div style={{ fontSize:13, color:isDark ? '#bbb' : '#555', marginBottom:6 }}>
              <strong>{ogrenci.ad} {ogrenci.soyad}</strong> adlı öğrenci kalıcı olarak silinecek.
            </div>
            <div style={{ fontSize:12, color:'#e74c3c', background:'#fff5f5', border:'1px solid #ffcccc', borderRadius:8, padding:'10px 12px', marginBottom:20 }}>
              Bu işlem geri alınamaz. Öğrencinin tüm ders hakları, kredi geçmişi ve yoklama kayıtları da silinir.
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button onClick={()=>setSilModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>İptal</button>
              <button onClick={ogrenciSil} disabled={siliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#c0392b', color:'white', cursor:'pointer', fontSize:13, fontWeight:600 }}>
                {siliyor ? 'Siliniyor...' : 'Evet, sil'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hesap birleştir modali */}
      {birlestirModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e=>{if(e.target===e.currentTarget)setBirlestirModal(false);}}>
          <div style={{ background:card, borderRadius:12, padding:24, width:460 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:6 }}>⇌ Hesap birleştir</div>
            <div style={{ fontSize:12, color:textSec, marginBottom:16, lineHeight:1.6 }}>
              <strong>{ogrenci.ad} {ogrenci.soyad}</strong> bu sayfadaki hesap silinir,
              tüm ders kayıtları, krediler ve yoklama geçmişi seçtiğiniz hesaba taşınır.
              Bu işlem geri alınamaz.
            </div>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Taşınacak hedef hesap (Google ile oluşan hesap)</div>
              <select value={hedefId} onChange={e=>setHedefId(e.target.value)}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                <option value="">-- Hedef hesabı seç --</option>
                {tumOgrenciler.map((o:any) => (
                  <option key={o.id} value={o.id}>{o.ad} {o.soyad} · {o.email}</option>
                ))}
              </select>
            </div>
            {hata && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={()=>setBirlestirModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>İptal</button>
              <button disabled={!hedefId || kaydediliyor} onClick={async () => {
                  if (!window.confirm('Bu işlem geri alınamaz. Emin misiniz?')) return;
                  setKaydediliyor(true); setHata('');
                  try {
                    const res = await api.post(`/api/ogrenciler/${id}/birlestir`, { hedef_id: hedefId });
                    setBirlestirModal(false);
                    navigate(`/ogrenciler/${res.data.ogrenci_id}`);
                  } catch (err:any) { setHata(err.response?.data?.hata||'Hata oluştu'); }
                  finally { setKaydediliyor(false); }
                }}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background: hedefId ? '#e24b4a' : '#ccc', color:'white', cursor: hedefId ? 'pointer' : 'not-allowed', fontSize:13 }}>
                {kaydediliyor ? 'İşleniyor...' : 'Birleştir ve sil'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OgrenciProfil;